module.exports = __webpack_public_path__ + "build/img/pud_s.fffa5e53.png";